import React from "react";
import './benefits.css';

// ....... images .......
import benefit1 from '../../../../assets/images/solution1.svg';
import benefit2 from '../../../../assets/images/solution2.svg';
import benefit3 from '../../../../assets/images/solution3.svg';


function Benefits() {
   return (
       <div className="content-box width-1000">
          <div className="benefit-main-title rubik-medium white-color text-align-center margin-b-40">Benefits</div>
          <ul className="benefits">
             <li className="flex hr-space-between">
                <div className="benefit-content">
                   <div className="small-title margin-b-20">
                      Create interactive product demos in minutes
                   </div>
                   <div className="description">
                      Send this as a pre-read or a leave behind. Let your viewers actively participate in the
                      interactive demo video by clicking on links, making selections, and providing inputs.
                   </div>
                </div>
                <div className="benefit-img icon">
                   <img src={benefit1} alt=""/>
                </div>
             </li>
             <li className="flex hr-space-between">
                <div className="benefit-img icon">
                   <img src={benefit2} alt=""/>
                </div>
                <div className="benefit-content">
                   <div className="small-title margin-b-20">
                      Get insights about your prospects
                   </div>
                   <div className="description">
                      No two prospects of yours are the same. We get it. With viewing insights and in-context comments
                      from your prospects, understand which features are driving the most interest, and get higher
                      quality leads.
                   </div>
                </div>
             </li>
             <li className="flex hr-space-between">
                <div className="benefit-content">
                   <div className="small-title margin-b-20">
                      Send personalized pitches effortlessly
                   </div>
                   <div className="description">
                      Personalize the experience for different user segments easily, whether by company or by persona.
                      Create many versions of the same interactive video and share with ease. That’s right, create once,
                      personalize as many times.
                   </div>
                </div>
                <div className="benefit-img icon">
                   <img src={benefit3} alt=""/>
                </div>
             </li>
          </ul>
       </div>
   )
}

export default Benefits;
